<template>
	<router-link :to="to || '/'">
		<v-sheet :color="background" rounded>
			<div :style="smAndDown ? `font-size: ${size || '1.5'}rem` : `font-size: ${size || '2'}rem`">
				<div class="d-flex" style="font-family: 'dorsa'">
					<div class="font-weight-thin text-grey-darken-2">PEEP</div>
					<div class="font-weight-bold text-red-darken-4">SHOW</div>
				</div>
			</div>
		</v-sheet>
	</router-link>
</template>
<script setup>
import { useDisplay } from 'vuetify/lib/framework.mjs'

const { smAndDown } = useDisplay()

const props = defineProps({
	to: [String, Object],
	brief: Boolean,
	light: Boolean,
	size: Number,
	color: String,
	print: Boolean,
    background: {
        type: String,
        default: 'transparent',
    },
})
</script>
